<template>
  <svg
    width="16"
    height="18"
    viewBox="0 0 16 18"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3 0C1.34315 0 0 1.34315 0 3V15C0 16.6569 1.34315 18 3 18C4.65685 18 6 16.6569 6 15V3C6 1.34315 4.65685 0 3 0ZM13 0C11.3431 0 10 1.34315 10 3V15C10 16.6569 11.3431 18 13 18C14.6569 18 16 16.6569 16 15V3C16 1.34315 14.6569 0 13 0Z"
      fill="#0F2D5A"
    />
  </svg>
</template>
